import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AdminGamesService } from '@admin-panel/infra';
import { GetAdminKnownRegionsResponse, RegionDto } from '@core-http';

export class GetKnownRegionsQueryHandler {
  private readonly adminGamesService: AdminGamesService = inject(AdminGamesService);

  query(): Observable<string[]> {
    return this.adminGamesService
      .getKnownRegions()
      .pipe(map((response: GetAdminKnownRegionsResponse) => response.knownRegions.map((r: RegionDto) => r.name)));
  }
}
